/* eslint-disable max-len */
import { ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

import trxQuestions from 'images/coin-pages/questions/trx.svg'

import { commonLearnMoreData, commonSlidesData } from '../commonPageData'

export const trxPage: ICoinPageData = {
  title: 'coin_947',
  description: 'coin_948',
  // description:
  //   'Borrow Tron against Stablecoins.' +
  //   ` Get a stablecoin loan using your TRX coin as collateral for ${PERCENTAGES.loan}% APR for an unlimited term.`,
  h1: (t, _, replacePlaceholders) => (
    <span
      dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'Tron (TRX)' }) }}
    />
  ),
  questionsBlock: {
    image: trxQuestions,
    questions: [
      {
        title: 'coin_949',
        answer: 'coin_950',
      },
      {
        title: 'coin_951',
        answer: 'coin_952',
      },
      {
        title: 'coin_953',
        answer: 'coin_954',
      },
      {
        title: 'coin_955',
        answer: 'coin_956',
      },
      {
        title: 'coin_957',
        answer: 'coin_958',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('Tron (TRX)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_959',
        text: ['coin_963'],
      },
      {
        title: 'coin_960',
        text: ['coin_964'],
      },
      {
        title: 'coin_961',
        text: ['coin_965', 'coin_966', 'coin_967', 'coin_968', 'coin_969'],
      },
      {
        title: 'coin_962',
        text: ['coin_970', 'coin_971', 'coin_972', 'coin_973', 'coin_974'],
      },
    ],
    ...commonLearnMoreData('Tron (TRX)'),
  },
}
